import { Column } from '@/styles/reactnative';
import { Modal } from 'antd';

interface IProps {
  children: React.ReactNode;
  title: string;
  onCancel: () => void;
  open: boolean;
  width?: number;
  onOk?: () => void;
  cancelText?: React.ReactNode;
  okText?: React.ReactNode;
  centered?: boolean;
  footer?: boolean;
}

const CustomModal = ({
  children,
  title,
  onCancel,
  onOk,
  open,
  width,
  cancelText = null,
  okText = null,
  centered = false,
  footer = false,
}: IProps) => {
  return (
    <Modal
      className={'custom-modal'}
      open={open}
      onCancel={onCancel}
      onOk={() => {
        onOk?.();
      }}
      cancelText={cancelText}
      okText={okText}
      centered={centered}
      footer={footer}
      width={width}
    >
      <Column style={{ gap: 16 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600 }}>{title}</h2>
        {children}
      </Column>
    </Modal>
  );
};

export default CustomModal;
